// extracted by mini-css-extract-plugin
module.exports = {"container":"Details_container__3chBe","detailsContainer":"Details_detailsContainer__2OyJC","flexGrowth":"Details_flexGrowth__3GU6L"};